angular.module('impactx.catalog').controller('CatalogPriceImportCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    '$timeout',
    'TranslationService',
    CatalogPriceImportCtrl
]);

function CatalogPriceImportCtrl($scope, dataGen, ToastService, $mdDialog) {
    var ctrl = this;

    $scope.uploadExcel = {};

    ctrl.import = function (event) {
        $scope.uploadInProgress = true;
        var paramObj = {
            id: ctrl.catId,
            file: $scope.uploadExcel.file
        };
        dataGen.uploadFile(paramObj, '/catalog/prices/import', true).then(function () {
            $scope.uploadInProgress = false;
            $mdDialog.hide();
            ToastService.openStandardToast($scope.trns.importSuccessful);
        }, function () {
            $scope.uploadInProgress = false;
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getTrns = function () {
        dataGen.getData($scope, {}, '/catalog/prices/importtrns');
    }

    ctrl.getTrns();
}